import React from "react";
import {useBuildTypeQueryQuery} from "../../generated/graphql";
import {GraphQlSelect} from "./GraphQlSelect";

export const SiteBuildTypeSelect = (props) => {
    const query = useBuildTypeQueryQuery();
    return <GraphQlSelect {...props} queryResult={query} labelField="label"/>;
}